<template>
  <el-drawer
      class="sideDrawer"
      destroy-on-close
      :size="drawerSize"
      :wrapperClosable="false"
      :close-on-press-escape="false"
      :title="title"
      :visible="dialogVisible"
      :before-close="beforeClose"
      @opened="onShowForm"
      append-to-body
  >
    <i class="iconfont icon-back-quanping iconFull" @click="drawerSize = '100%'" v-if="drawerSize == '70%'" />
    <i @click="drawerSize = '70%'" class="iconfont icon-back-tuichuquanping iconFull" v-else />
    <el-form style="padding: 20px 20px 0 0" ref="form" :model="rulesData" label-width="80px" :rules="rules" :inline="true">
      <el-form-item label="规则名称" prop="name">
        <el-input v-model="rulesData.name" />
      </el-form-item>
    </el-form>
    <!--控制条件规则-->
    <rule-config-table
        ref="ruleConfigTable"
        :isEdit="isEdit"
        :rulesData="rulesData"
        :ruleDetailData="ruleDetailData"
        @dataChange="changeTableData"
    ></rule-config-table>

    <div class="demo-drawer__footer">
      <el-button @click="beforeClose">取消</el-button>
      <el-button @click="submit('form')" type="primary" :loading="loading">确定</el-button>
    </div>
  </el-drawer>
</template>

<script>
import form from '@/api/form'
import req from '@/request'
const ruleConfigTable = () => import('./ruleConfigTable.vue')

export default {
  name: 'ContractRuleForm',
  props: {
    dialogVisible: {
      type: Boolean,
      default: () => false
    },
    rulesData: {
      type: Object,
      default: () => {}
    },
    isEdit: {
      type: Boolean,
      default: () => false
    }
  },
  components: {
    ruleConfigTable
  },
  data() {
    return {
      title: '审查规则',
      drawerSize: '70%',
      ruleDetailData: [],
      loading: false,
      pageBean: {
        page: 1,
        pageSize: 999,
        total: 0
      },
      rules: {
        name: [{ required: true, message: '请输入规则名称', trigger: 'blur' }]
      }
    }
  },
  mounted() {
  },
  methods: {
    async getDetail() {
      if (this.rulesData && this.rulesData.id) {
        await this.$http.get('${portal}/rule/portal_contract_rule/detail/' + this.rulesData.id).then((res) => {
          if (res.data) {
            this.isEdit = true
            this.ruleDetailData = res.data
            this.dialogVisible = true
            // this.$refs.rulesForm.resetFields()
            // console.info(this.ruleDetailData)
          }
        })
      }
    },
    onShowForm() {
      if (this.isEdit) {
        this.getDetail()
      } else {
        this.rulesData = {};
        this.ruleDetailData = [];
      }

    },
    submit(formName) {
      this.$refs[formName].validate((valid) => {
        this.loading = true
        if (valid) {
          let isSubmit = false
          if (this.rulesData && this.ruleDetailData.length > 0) {
            let rowNum = 0;
            this.ruleDetailData.forEach((ruleDetail) => {
              rowNum ++
              if (!ruleDetail.ruleName) {
                this.$message.warning('请输入第' + rowNum + '行的规则名称')
                this.loading = false
                isSubmit = false
                return
              }
              if (!ruleDetail.riskLevel) {
                this.$message.warning('请选择第' + rowNum + '行的风险等级')
                this.loading = false
                isSubmit = false
                return
              }
              if (!ruleDetail.ruleDesc) {
                this.$message.warning('请输入第' + rowNum + '行的规则描述')
                this.loading = false
                isSubmit = false
                return
              }
              isSubmit = true
            })
          } else {
            this.$message.warning('请添加规则')
            this.loading = false
            isSubmit = false
            return
          }
          if (isSubmit) {
            let params = Object.assign({}, this.rulesData)
            params.rule_detail = this.ruleDetailData
            if (params.id) {
              req.put('${portal}/rule/portal_contract_rule/', params)
                  .then(() => {
                    this.loading = false
                    this.beforeClose()
                  })
                  .catch(() => {
                    this.loading = false
                  })
            } else {
              req.post('${portal}/rule/portal_contract_rule/', params)
                  .then(() => {
                    this.loading = false
                    this.beforeClose()
                  })
                  .catch(() => {
                    this.loading = false
                  })
            }
          }
        } else {
          this.loading = false
          console.log('error submit!!')
          return false
        }
      })
    },
    changeTableData(tableData) {
      this.ruleDetailData = tableData
    },
    beforeClose() {
      // this.$refs["form"].resetFields();
      this.$emit('beforeClose')
      this.rulesData = {
        id: '',
        name: ''
      }
    },
  }
}
</script>

<style scoped></style>
